import { useTranslations } from 'next-intl';

import useDisplayBestBuy from '@/app/hooks/useDisplayBestBuy';

import InStoreSizingOption from './InStoreSizingOption';
import SizingPageSection from './SizingPageSection';

const InStoreSizingSection = (): JSX.Element => {
  const isBestBuyCountry = useDisplayBestBuy();
  const t = useTranslations();

  if (!isBestBuyCountry) return <></>;

  return (
    <SizingPageSection
      data-cy="in-store-sizing-section"
      heading={{ content: 'sizing_in_store_now' }}
    >
      <InStoreSizingOption
        content={t.rich('sizing_bestbuy_store')}
        cta={{
          href: '/best-buy/store-locator',
          label: 'sizing_bestbuy_store_locator',
        }}
        name="best_buy"
      />
    </SizingPageSection>
  );
};

export default InStoreSizingSection;
